import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { IntercomService } from './intercom.service';

import { INTERCOM_CONFIG, IntercomConfig } from './intercom-config';

@NgModule({
  imports: [CommonModule],
  providers: [IntercomService],
})
export class IntercomModule {
  static forRoot(config: IntercomConfig): ModuleWithProviders<IntercomModule> {
    return {
      ngModule: IntercomModule,
      providers: [
        {
          provide: INTERCOM_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
